module.exports = __webpack_public_path__ + "assets/img/zhaoqing-64f38856.png";